var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInputShowHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C9.32189 7.5 8.67155 7.76339 8.19206 8.23223C7.71256 8.70107 7.44318 9.33696 7.44318 10C7.44318 10.663 7.71256 11.2989 8.19206 11.7678C8.67155 12.2366 9.32189 12.5 10 12.5C10.6781 12.5 11.3284 12.2366 11.8079 11.7678C12.2874 11.2989 12.5568 10.663 12.5568 10C12.5568 9.33696 12.2874 8.70107 11.8079 8.23223C11.3284 7.76339 10.6781 7.5 10 7.5ZM10 14.1667C8.86982 14.1667 7.78592 13.7277 6.98676 12.9463C6.1876 12.1649 5.73864 11.1051 5.73864 10C5.73864 8.89493 6.1876 7.83512 6.98676 7.05372C7.78592 6.27232 8.86982 5.83333 10 5.83333C11.1302 5.83333 12.2141 6.27232 13.0132 7.05372C13.8124 7.83512 14.2614 8.89493 14.2614 10C14.2614 11.1051 13.8124 12.1649 13.0132 12.9463C12.2141 13.7277 11.1302 14.1667 10 14.1667ZM10 3.75C5.73864 3.75 2.09943 6.34167 0.625 10C2.09943 13.6583 5.73864 16.25 10 16.25C14.2614 16.25 17.9006 13.6583 19.375 10C17.9006 6.34167 14.2614 3.75 10 3.75Z",
    fill: "#4B68CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInputShowHover);
export default __webpack_public_path__ + "static/media/icn_input_show_hover.d2c217100b97326c874efe287af29e58.svg";
export { ForwardRef as ReactComponent };